export enum VideoPlayerEventTypes {
    BUFFER_EMPTY,
    BUFFER_EMPTY_NO_RECOVERY,
    SAFARI_AUTO_PLAY_PAUSE,
    PLAYBACK_READY
}
